import React from 'react'
import Resx from '@/components/Resx'
import { formatDate } from '@/utils/dateUtilities'
import { prepareLastComments } from './TopBarComments.DataSource'

class TopBarComments extends React.Component {
  formatTime (date) { return formatDate(date, 'DD.MM.YYYY HH:mm') }
  renderComment (comment) {
    if (comment.isEmpty === true) { return <div className='comment'>-</div> }
    return (
      <div className='comment'>
        <div className='comment__top'>
          <div className='comment__author'><i className='icon-profile' /> {comment.author}</div>
          <time>{this.formatTime(comment.creationTime)}</time>
        </div>
        <div className='comment__text' dangerouslySetInnerHTML={{ __html: comment.text }}>

          {/* <a className="link__more"><Resx name="Tasks.More" /></a> */}
        </div>
      </div>
    )
  }
  render () {
    const { task } = this.props
    const comment = prepareLastComments(task)
    return (
      <React.Fragment>
        <h3><Resx name='Tasks.LastComments' /></h3>
        <div className='comments'>
          {this.renderComment(comment)}
          {!!comment.answer &&
          <div className='comment comment--reply'>
            <div className='comment__top'>
              <div className='comment__author'><i className='icon-profile' /> {comment.answer.author}</div>
              <time>{this.formatTime(comment.answer.creationTime)}</time>
            </div>
            <div className='comment__text' dangerouslySetInnerHTML={{ __html: comment.answer.text }} />
          </div>
          }
        </div>
      </React.Fragment>
    )
  }
}

export default TopBarComments



// WEBPACK FOOTER //
// ./src/internal-app/components/comments/TopBarComments.js